export const SPACE_LEVELS = ["4px", "8px", "16px", "32px", "64px", "128px"];
